import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

// Components
import DataSlot from 'components/atoms/DataSlot';

// Utils
import { formatTime } from 'utils/date';

const TimeSlot = ({
  active,
  date,
  onClick,
  intl,
  hasPromotion,
  amPmAriaLabel
}) => {
  const time = formatTime(date, intl, false, true);
  return (
    <DataSlot
      bsStyle="primary"
      onClick={() => {
        onClick(date);
      }}
      value={time}
      active={active}
      hasPromotion={hasPromotion}
      dataSlotAriaLabel={time + ' ' + amPmAriaLabel}
    />
  );
};

TimeSlot.propTypes = {
  /** Boolean indicating whether the timeslot has been selected */
  active: PropTypes.bool,
  date: PropTypes.object.isRequired,
  hasPromotion: PropTypes.bool,
  intl: PropTypes.object,
  onClick: PropTypes.func,
  amPmAriaLabel: PropTypes.string
};

TimeSlot.defaultProps = {
  active: false,
  onClick: () => {}
};

export default injectIntl(TimeSlot);



// WEBPACK FOOTER //
// ./src/components/atoms/TimeSlot/TimeSlot.js